"use strict";

/** @format */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizeClassesStar = exports.starWidthStar = void 0;
exports.starWidthStar = {
  small: 16,
  medium: 16,
  large: 24
};
exports.sizeClassesStar = {
  small: {
    text: 'hmf-body-s',
    quantity: 'hmf-body-s'
  },
  medium: {
    text: 'hmf-body-l',
    quantity: 'hmf-body-l'
  },
  large: {
    text: 'hmf-body-bold-l',
    quantity: 'hmf-body-l'
  }
};
